//
//
//
//
//

import Drip from 'drip';
export default {
  name: 'go-home-page',
  destroyed: function destroyed() {
    this.goHomeView();
  },
  methods: {
    goHome: function goHome() {
      this.goHomeClick();
      if (Drip.UA.IS_DouyinShowMicroApp) {
        window.tt.miniProgram.switchTab({
          url: '/pages/show/index/index'
        });
      } else if (Drip.UA.IS_MAOYAN_XHS_APP || Drip.UA.IS_MAOYAN_XHSMOVIE) {
        window.xhs.miniProgram.switchTab({
          url: '/pages/show/index/index'
        });
      } else if (Drip.UA.IS_MAOYAN) {
        Drip.constant.gotoShowHomeTab();
      } else if (Drip.UA.IS_MAOYAN_BAIDU_APP) {
        window.swan.webView.switchTab({
          url: '/pages/tabshow/index'
        });
      } else {
        Drip.redirect('/myshow/index.html');
      }
    },
    goHomeView: function goHomeView() {
      function stats() {
        try {
          window.seedAction({
            evt: 'view',
            bid: 'b_movie_8bww82m4_mv',
            cid: 'c_Q7wY4'
          });
        } catch (error) {
          console.log('error', error);
        }
      }
      // 防止 Analytics未初始化
      if (!window.seedAction) {
        setTimeout(stats, 100);
      } else {
        stats();
      }
    },
    goHomeClick: function goHomeClick() {
      try {
        window.seedAction({
          evt: 'click',
          bid: 'b_movie_wnsq5p4t_mc',
          cid: 'c_Q7wY4'
        });
      } catch (error) {}
    }
  }
};